export { default } from "./ViewAllAssignments";
